
export const CRYPTO_KEY = process.env.REACT_APP_KEY;
export const CRYPTO_IV = process.env.REACT_APP_IV;
export const APP_NAME = 'KHAT';
export const PRODUCTION =true;
export const AWS_STORAGE_BUCKET_NAME = process.env.REACT_APP_AWS_STORAGE_BUCKET_NAME;
export const AWS_ACCESS_KEY_ID = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
export const AWS_SECRET_ACCESS_KEY = process.env.REACT_APP_AWS_SECRET_ACCESS_KEY;
export const AWS_S3_REGION_NAME = process.env.REACT_APP_AWS_S3_REGION_NAME;
export const OTHER_PATH=''
export const API_KEY = process.env.REACT_APP_API_KEY;
export const BASE_URL = PRODUCTION ? process.env.REACT_APP_LIVE_API_BASE_URL || '' : process.env.REACT_APP_API_BASE_URL || '';
// HTTPS requests
export const GET = "get";
export const POST = "post";
export const PUT = "put";
export const PATCH = "patch";
export const DELETE = "delete";
export const OPTION = "options";

//constants 
export const AUTH = "auth";
export const ADMIN = "admin";
export const COMPANY = "company";
export const CLIENT = "client";
export const COMMON = "common";
export const OTHERS = "other";

export const SHARE_WORKSHEET = "SHARE_WORKSHEET";
export const ADD_MISSING_TEXT = "ADD_MISSING_TEXT";
export const ADD_INCORRECT_ANSWER_TEXT = "ADD_INCORRECT_ANSWER_TEXT";

export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_YEAR_WISE_DASH_TIME_FORMAT = "YYYY-MM-DD h:mm A";
export const DATE_SLASH_FORMAT = "DD/MM/YYYY";
export const TASK_DATE_FORMAT = "DD MMM,YYYY";
export const SEARCH_DELAY = 1000;
export const ITEM_PER_PAGE = 10;

// model
export const SWEET_ALERT_OK_COLOR = "#d33";
export const SWEET_ALERT_CANCEL_COLOR = "#3085d6";

export const PUBLIC_URL=process.env.PUBLIC_URL
